import PropTypes from 'prop-types';
import { Modal, Box, CircularProgress } from '@mui/material';
import colors from 'assets/theme/base/colors';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import MDBox from 'components/MDBox';

/**
 * Confirmation before changing record status via the header stepper.
 */
export default function StatusStepperConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  onConfirm,
  onCancel,
  loading = false,
  confirmColor = 'primary',
}) {
  return (
    <Modal
      open={open}
      onClose={loading ? undefined : onCancel}
      aria-labelledby="status-stepper-confirm-title"
      aria-describedby="status-stepper-confirm-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          maxWidth: 'calc(100vw - 32px)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Box className="pearl-popup-header"
          sx={{
            backgroundColor: colors.popupHeader.background,
            px: 4,
            py: 3,
          }}
        >
          <MDTypography
            id="status-stepper-confirm-title"
            variant="h6"
            component="h2"
            sx={{ color: '#FFFFFF' }}
          >
            {title}
          </MDTypography>
        </Box>

        <Box sx={{ p: 4 }}>
          <MDTypography
            id="status-stepper-confirm-description"
            variant="body1"
            mb={3}
            sx={{ color: '#34495e' }}
          >
            {message}
          </MDTypography>

          <MDBox display="flex" justifyContent="flex-end" mt={3}>
            <MDButton
              onClick={onCancel}
              variant="outlined"
              color="secondary"
              disabled={loading}
              sx={{ marginRight: 2 }}
            >
              Cancel
            </MDButton>
            <MDButton
              onClick={onConfirm}
              variant="gradient"
              color={confirmColor}
              disabled={loading}
            >
              {loading ? <CircularProgress size={22} color="inherit" /> : confirmLabel}
            </MDButton>
          </MDBox>
        </Box>
      </Box>
    </Modal>
  );
}

StatusStepperConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  confirmColor: PropTypes.string,
};
